import styles from "./toolbox-components.module.css";

export interface ToolboxComponentToggleProps {
  optionTitles: string[];
  selectedOptionIndex: number;
  onClickOption: (optionIndex: number) => void;
}

export const ToolboxComponentToggle = (props: ToolboxComponentToggleProps) => {
  return (
    <div className={styles.toggleContainer}>
      <div className={styles.toggleOptionsContainer}>
        {props.optionTitles.map((title, index) => (
          <button
            key={index}
            className={`${styles.toggleOption} ${
              index === props.selectedOptionIndex
                ? styles.toggleOptionSelected
                : ""
            }`}
            onClick={() => props.onClickOption(index)}
          >
            {title}
          </button>
        ))}
      </div>
    </div>
  );
};
